const SAFE_LINK = /^https?:\/\//i

function LegalLink({ href, label }: { href?: string; label: string }): React.ReactElement | null {
  // The API validates these on save; this covers anything stored before it did.
  if (!href || !SAFE_LINK.test(href)) return null
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whitespace-nowrap underline underline-offset-2 hover:text-gray-700 dark:hover:text-gray-200"
    >
      {label}
    </a>
  )
}

/** A tenant's own terms and privacy links. Renders nothing for those not set. */
export function LegalLinks({
  termsUrl,
  privacyUrl,
}: {
  termsUrl?: string
  privacyUrl?: string
}): React.ReactElement {
  return (
    <>
      <LegalLink href={termsUrl} label="Terms" />
      <LegalLink href={privacyUrl} label="Privacy" />
    </>
  )
}
